<template>
    <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="12">
            <v-card class="elevation-4">

                <v-card-title>
                    <v-toolbar flat>
                        <v-btn small dark color="cyan darken-4" @click="dialog = true">
                            <v-icon left>fas fa-plus-square</v-icon>Nuevo empleado
                        </v-btn>

                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-col cols="12" md="8" sm="12" class="d-flex justify-end">
                        <v-text-field v-model="search" append-icon="fas fa-search" label="Buscar empleado" single-inline hide-details @keydown.enter="searchEmpleado"></v-text-field>

                        <v-btn icon class="mt-4 ml-2" @click="reload()" title="Actualizar"><v-icon dense>fas fa-sync</v-icon></v-btn>
                        <Columns :headers.sync="headers"></Columns>
                    </v-col>
                </v-card-title>

                <v-card-text>
                <v-data-table dense :headers="filteredHeaders" :items="empleados" class="elevation-1"
                :loading="loading" :options.sync="options"
                :server-items-length="totalElements" :items-per-page="itemsPerPage"
                :page.sync="page" @page-count="totalPages = $event"
                hide-default-footer>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-menu bottom offset-x rounded="lg" transition="slide-y-transition" color="primary">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" color="teal darken-1" class="white--text" small>
                                    <v-icon>fas fa-ellipsis-v</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                 <v-list-item disabled>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>Empleado: {{ item.nombreCompleto }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item @click.prevent="editarEmpleado(item)" v-if="!item.eliminado">
                                    <v-list-item-title>
                                        <v-icon small>fas fa-edit</v-icon> Editar empleado
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click.prevent="deleteEmpleado(item)" v-if="!item.eliminado">
                                    <v-list-item-title class="red--text">
                                        <v-icon small class="red--text">fas fa-trash-alt</v-icon> Borrar empleado
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                    <template v-slot:[`item.eliminado`]="{item}">
                        <v-chip :color="getColor(item.eliminado)" dark x-small v-text="item.eliminado == false ? 'Activo' : 'Inactivo'" ></v-chip>
                    </template>
                </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <PaginationNumber :itemsPerPage.sync="itemsPerPage" :pageCount.sync="totalPages"
                    :totalElements.sync="totalElements" :page.sync="page" :initialize.sync="initialize" />
                </v-card-actions>

            </v-card>
        </v-col>
        
        <ModalNuevoEmpleado :dialog.sync="dialog" :lstEmpleados.sync="initTableEmployee"
        :generos.sync="generos" :tipoSalario.sync="tipoSalario" :puestos.sync="puestos"
        :departamentos.sync="departamentos" :empresas.sync="empresas"
        v-if="dialog" :handleModal="handleModal">
        </ModalNuevoEmpleado>

        <ModalEditarEmpleado :dialog.sync="dialogEdit" :empleado.sync="dataEmpleado"
        :generos.sync="generos" :tipoSalario.sync="tipoSalario" :puestos.sync="puestos"
        :departamentos.sync="departamentos" :empresas.sync="empresas"
        :lstEmpleados.sync="initTableEmployee" v-if="dialogEdit" :handleModal="handleEditModal">
        </ModalEditarEmpleado>
    </v-row>
</template>

<script>
import GeneroDataService from '@/service/catalogo/genero/generoDataService';
import PuestoDataService from '@/service/catalogo/puesto/puestoDataService';
import DepartamentoDataService from '@/service/catalogo/departamento/departamentoDataService';
import EmpresaDataService from '@/service/catalogo/empresa/empresaDataService';
import TipoSalarioDataService from '@/service/catalogo/tipoSalario/tipoSalarioDataService';

import EmpleadoDataService from '@/service/empleado/empleadoDataService';
import ModalNuevoEmpleado from './NuevoEmpleado.vue';
import ModalEditarEmpleado from './EditarEmpleado.vue';
import { pagedTableMixin } from '@/mixins/serverTableMixin';
import Columns from '@/components/shared/Columns.vue';
import PaginationNumber from '@/components/shared/PaginationNumber.vue';
import { extractMessage } from '@/helpers/errorHelper';

export default {
    name: 'ListaEmpleado',
    mixins: [pagedTableMixin],
    components: { ModalNuevoEmpleado, ModalEditarEmpleado, Columns, PaginationNumber },
    created() {
        this.fetchTableData();
        this.getGeneros();
        this.getTipoSalario();
        this.getPuestos();
        this.getDepartamentos();
        this.getEmpresas();
    },
    data() {
        return {
            generos       : [],
            tipoSalario   : [],
            puestos       : [],
            departamentos : [],
            empresas      : [],

            empleados     : [],

            dialog        : false,
            dialogEdit    : false,

            dataEmpleado  : [],
            headers: [
                { text: 'Acciones', value: 'actions', sortable: false, groupable: false, show: true },
                { text : 'ID', sortable : false, value: 'id', align: ' d-none', visible: false, groupable: false, show: false },
                { text: 'Nombre Completo', value: 'nombreCompleto', align: 'start', sortable: false, groupable: false, show: true },
                { text: 'Empresa', value: 'empresa.razonSocial', sortable: false, groupable: false, show: true },
                { text: 'Sucursal', value: 'sucursal.nombre', sortable: false, groupable: false, show: true },
                { text: 'Departamento', value: 'departamento.departamento', sortable: false, groupable: false, show: true },
                { text: 'Puesto', value: 'puesto.puesto', sortable: false, groupable: false, show: true },
                { text: 'Celular', value: 'celular', sortable: false, groupable: false, show: true },
                { text: 'Dirección', value: 'direccion', sortable: false, groupable: false, show: true },
                { text: 'Estatus', value: 'eliminado', sortable: false, groupable: false, show: true },
            ]
        }
    },
    methods: {
        searchEmpleado() {
            this.doSearch();
        },
        fetchTable(params){
            return EmpleadoDataService.table( params );
        },
        applyRows({ rows, total, totalPages }){
            this.empleados = rows;
            this.totalElements = total;
            this.totalPages = totalPages;
        },
        // Callback que reciben los diálogos de alta y edición.
        initTableEmployee(){
            this.reload();
        },
        editarEmpleado( item ) {
            this.dataEmpleado = item;
            this.dialogEdit = true;
        },
        deleteEmpleado( item ) {
            const message = item.usuarioId 
                ? 'Al bloquear al empleado se desactivará su registro asociado (usuario).'
                : 'Al bloquear al empleado no se podrá revertir la acción.';

            this.$swal.fire({
                title: 'Estas seguro de bloquear el empleado?',
                text: message,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, eliminar empleado!',
            }).then(result => {

                if (result.isConfirmed) {
                    EmpleadoDataService.delete( item.id ).then( resp => {
                        this.initTableEmployee();
                        this.$swal.fire({ position: 'top-end', title: 'Borrado', text: '¡Empleado eliminado exitosamente!', icon: 'success', showConfirmButton: false, timer: 1500 });
                    }).catch( err => {
                        this.$swal.fire({ position: 'top-end', title: 'Error', text: extractMessage(err), icon: 'error', showConfirmButton: false, timer: 1500 });
                    });
                }

            });
        },
        getColor( status ){ return ( status ) ? 'pink' : 'primary'; },
        handleModal() { this.dialog = !this.dialog; },
        handleEditModal() { this.dialogEdit = !this.dialogEdit; },
        async getGeneros() {
            this.generos = await GeneroDataService.all().then( g => g.data ) || [];
        },
        async getTipoSalario() {
            this.tipoSalario = await TipoSalarioDataService.lstTipoSalario().then( t => t.data ) || [];
        },
        async getPuestos() {
            this.puestos = await PuestoDataService.getallPuesto().then( r => r.data ) || [];
        },
        async getDepartamentos() {
            this.departamentos = await DepartamentoDataService.getallDepartamento().then( d => d.data ) || [];
        },
        async getEmpresas() {
            this.empresas = await EmpresaDataService.lstEmpresa().then( e => e.data ) || [];
        }
    },

    computed: {
        filteredHeaders() { return this.headers.filter( header => header.show ); }
    }
}
</script>